import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, Observable, take, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MODAL_TOKEN, ModalProvider } from '../tokens';
import { PresentModalComponent } from '../modals';
import { ErrorModel } from '../interfaces';
import { getErrorMessage } from '../mappers';
import { ErrorEnum } from '../enums';
import { AppRoutes } from '../routes';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly router: Router = inject(Router);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const knownException: ErrorEnum = error?.error?.knownException;
        const messageForClient: ErrorModel = error?.error?.messageForClient;

        if (error.status === 401) {
          return throwError(() => error);
        }

        const mappedError: ErrorModel = getErrorMessage(knownException, messageForClient);

        if (mappedError.isUnknown) {
          this.showConnectionError(error.status === 0);
          return EMPTY;
        }

        this.openModal(mappedError);

        if (knownException) {
          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }

  private openModal(error: ErrorModel): void {
    this.modalProvider.dismissLoading$().pipe(take(1)).subscribe();

    this.modalProvider
      .showModal$({
        component: PresentModalComponent,
        componentProps: {
          header: error.title,
          message: error.message,
          btnTxt: 'Zamknij'
        },
        cssClass: 'present-modal'
      })
      .pipe(take(1))
      .subscribe();
  }

  private showConnectionError(isOffline: boolean): void {
    this.modalProvider.dismissLoading$().pipe(take(1)).subscribe();
    this.modalProvider.dismissAllStoredModals();

    if (this.router.url.includes(AppRoutes.CONNECTION_ERROR)) {
      return;
    }

    this.router.navigate([`/${AppRoutes.CONNECTION_ERROR}`], { queryParams: { offline: isOffline } });
  }
}
